import { BulkScopes } from 'UI/constants/defaults';
import { EntityType } from 'UI/constants/entityTypes';

export const createBulkEmailData = data => {
  const baseData = {
    instructions: data.instructions || '',
    tone: data.tone?.title || '',
    audience: data.audience?.title || '',
    length: data.length?.title || '',
    type: data.bulkScope.title,
    template: data.emailBody || '',
    candidates: null,
    jobOrders: null
  };

  if (data.bulkScope.id === BulkScopes.Marketing) {
    return {
      ...baseData,
      candidates:
        data.candidates.map(candidate => ({
          id: candidate.id,
          name: candidate.full_name,
          title: candidate.title,
          industry: candidate.industry || '',
          specialty: candidate.specialty || '',
          subspecialty: candidate.subspecialty || '',
          state: candidate.state || '',
          city: candidate.city || '',
          postalCode: candidate.zip || ''
        })) || []
    };
  }

  if (data.bulkScope.id === BulkScopes.Recruiting) {
    return {
      ...baseData,
      jobOrders:
        data.jobOrders.map(job => ({
          id: job.id,
          title: job.title,
          industry: job.industry || '',
          specialty: job.specialty || '',
          subspecialty: job.subspecialty || '',
          state: job.state_name || '',
          city: job.city_name || '',
          postalCode: job.zip || ''
        })) || []
    };
  }

  return baseData;
};

export const determineEntityType = ({ jobOrders, candidates }) => {
  if (jobOrders?.length > 0) return EntityType.Joborder;
  if (candidates?.length > 0) return EntityType.Candidate;
  return null;
};

export const shouldEnableAIDrawer = ({ isAIDrawerOpen, entityIds }) => {
  return isAIDrawerOpen && entityIds?.length > 0;
};

export const buildEntityEndpoint = ({ endpoint, queryParams, entityIds }) => {
  if (!endpoint || !entityIds?.length) return null;

  const params = { ...queryParams, ids: entityIds.join(',') };
  // Why not use query-string?
  return `${endpoint}?${new URLSearchParams(params).toString()}`;
};

export const formatEmailContent = variant => {
  return `<p><strong>Subject: </strong><span>${variant.subject}</span></p>${variant.body}`;
};

/**
 *
 * @param {Object} bulkData
 * @param {Object} [config]
 * @param {boolean} [config.isAIRecruitingFeatureActive ]
 * @returns {boolean}
 */
export const isBulkEmailAIEnabled = (bulkData, config = {}) => {
  if (!bulkData?.bulkScope || !bulkData.to) return false;

  const { bulkScope, marketCandidates, jobOrderRecruitment } = bulkData;

  if (!bulkScope || !bulkScope.id) return false;

  if (bulkScope.id === BulkScopes.General) return false;

  if (bulkScope.id === BulkScopes.Marketing) {
    return marketCandidates?.length > 0;
  }

  if (bulkScope.id === BulkScopes.Recruiting) {
    return !!(jobOrderRecruitment?.length > 0 && config?.isAIRecruitingFeatureActive);
  }

  return true;
};

export const areEntityIdsDifferent = ({ currentEntities, newEntities }) => {
  const currentIds = currentEntities?.map(item => item.id) || [];
  const newIds = newEntities?.map(item => item.id) || [];

  if (currentIds.length !== newIds.length) return true;

  const newIdsSet = new Set(newIds);
  return !currentIds.every(id => newIdsSet.has(id));
};
